import { CountUp } from "../CountUp";
import { Reveal } from "../Reveal";
import { fmtMoney } from "../../lib/format";

export const CostComparison = ({ calc }) => {
  const projectedPct = Math.min((calc.projectedThreeYear / Math.max(calc.currentThreeYear, 1)) * 100, 100);

  return (
    <div data-testid="cost-comparison" className="mt-24">
      <Reveal className="max-w-2xl">
        <h3 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
          The Cost of <span className="text-danger">Doing Nothing.</span>
        </h3>
      </Reveal>

      <div className="mt-12 grid items-stretch gap-6 lg:grid-cols-[1fr_auto_1fr]">
        <Reveal delay={0.05}>
          <div className="flex h-full flex-col rounded-3xl border border-danger/30 bg-danger/5 p-8">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">
              Stay with your current processor
            </p>
            <CountUp
              value={calc.currentThreeYear}
              format={fmtMoney}
              testid="current-3y-cost"
              className="mt-4 font-mono text-4xl font-bold text-white sm:text-5xl"
            />
            <p className="mt-2 text-sm text-white/50">estimated processing costs over 3 years</p>
            <div className="mt-auto pt-8">
              <div className="h-2 w-full rounded-full bg-danger/60" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="flex flex-col items-center justify-center px-2 py-4 text-center">
          <span className="font-mono text-xs tracking-[0.3em] text-white/40">VS.</span>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-mint">
            Potential savings
          </p>
          <CountUp
            value={calc.three}
            format={fmtMoney}
            testid="comparison-savings"
            className="animate-mint-pulse mt-2 font-mono text-4xl font-bold text-mint sm:text-5xl"
          />
        </Reveal>

        <Reveal delay={0.25}>
          <div className="flex h-full flex-col rounded-3xl border border-mint/30 bg-mint/5 p-8 shadow-[0_0_40px_rgba(0,156,222,0.08)]">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">
              Projected with CardConnect Commerce
            </p>
            <CountUp
              value={calc.projectedThreeYear}
              format={fmtMoney}
              testid="projected-3y-cost"
              className="mt-4 font-mono text-4xl font-bold text-mint sm:text-5xl"
            />
            <p className="mt-2 text-sm text-white/50">estimated processing costs over 3 years</p>
            <div className="mt-auto pt-8">
              <div className="h-2 rounded-full bg-mint/70" style={{ width: `${projectedPct}%` }} />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
};
